
import { Component, OnInit, SimpleChanges } from '@angular/core';
import { Observable, UnaryFunction, pipe } from 'rxjs';
import { finalize, shareReplay, takeUntil } from 'rxjs/operators';

import { ChipListSelectSearchComponent } from '../chip-list-select-search.component';
import { BaseChipListSelectSearchProperties } from './base-chip-list-select-search-properties.component';


@Component({
    templateUrl: './base-chip-list-select-search-template.html',
    imports: [
        ChipListSelectSearchComponent
    ]
})

export abstract class BaseChipListSelectSearch extends BaseChipListSelectSearchProperties implements OnInit {

  //#region base

  baseObserver = {
    next: (items) => {
      this.items = items;
    },
    error: (error) => {
      this.emitError();
    },
    complete: () => {
      this.initLoading = false;
      this.isFetchData = true;
    }
  };

  basePipeOperators = <T>() => pipe(
    shareReplay(),
    takeUntil(this.onDestroy$),
    finalize(() => {
      this.initLoading = false;
      this.isFetchData = true;
    })
  ) as UnaryFunction<Observable<T>, Observable<T>>;


  //#endregion



  ngOnInit() {
    this.initConfig();
    this.getItems();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['id']) this.getItems();
    if (changes['updateItems']) this.getItems();
  }


  /**
   * Default Config :
 * @param optionValue -> "id";
 * @param optionTitle -> "name";
 */
  initConfig() {
    this.optionValue = this.optionValue || "id";
    this.optionTitle = this.optionTitle || "name";
  }


  getItems() {
    if (this.initLoading) return;
    this.isFetchData = false;
    this.initLoading = true;
    this.getItemsApi();
  }

  /**
 Must be implemented by the child component
  */
  abstract getItemsApi();


  //emit option
  emitOptions(event) {
    this.itemsChange.emit(event);
  }

  emitOptionValues(event) {
    this.valuesChange.emit(event);
  }

  emitError() {
    this.onError.emit(true);
  }

  setFilteredItems(event) {
    this.filteredItem.emit(event);
  }

}
